import { render, staticRenderFns } from "./ChapterMenu.vue?vue&type=template&id=77cd641c&scoped=true&"
import script from "./ChapterMenu.vue?vue&type=script&lang=ts&"
export * from "./ChapterMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ChapterMenu.vue?vue&type=style&index=0&id=77cd641c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cd641c",
  null
  
)

export default component.exports